import { AutozoneColorPalette } from "../types";

export const AutozoneColorPaletteOptions = [
  { value: AutozoneColorPalette.DEFAULT, label: "Default" },
  { value: AutozoneColorPalette.NDVI, label: "NDVI" },
  { value: AutozoneColorPalette.ACCESSIBILITY, label: "Accessibility" },
];
